import React from "react";
import { Breadcrumb } from "antd";
import ServiceTabsDetail from "./ServiceTabsDetail";
import { useState } from "react";

const ServiceDetail = () => {
  const [breadcrumb,setBreadcrumb] = useState("Banner")
  return (
    <div className="mb-6">
      <h1 className="text-xl sm:text-3xl font-semibold sm:mb-1">Service Detail</h1>
      <div className="mb-4">
        <Breadcrumb
          separator=">"
          items={[{ title: "Service Detail" }, { title: breadcrumb }]}
        />
      </div>
      <ServiceTabsDetail setBreadcrumb={setBreadcrumb}/>
    </div>
  );
};

export default ServiceDetail;
